import { Dropdown, type DropdownChangeEvent } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { type CountryCode } from "@relay/accountEditBaseDataScreen_EditPrivateBaseDataMutation.graphql";
import { countryCodeOptions } from "./residence-dropdown.consts";
import { type RenderConfig } from "../ValidatedField";

export const ResidenceDropdown = ({
	fieldName,
	fieldValue,
	updateField,
	disabled,
	onChange,
	isValid,
	required,
	placeholder,
}: RenderConfig<CountryCode>) => {
	const checkIfDropdownFieldChanged = (e: any) => {
		if (e.value !== fieldValue) {
			if (onChange) {
				onChange();
			}
		}
	};

	return (
		<Dropdown
			options={countryCodeOptions}
			name={fieldName}
			disabled={disabled}
			required={required}
			placeholder={placeholder}
			onChange={(dropdownChangeEvent: DropdownChangeEvent) => {
				updateField(dropdownChangeEvent.value);
				checkIfDropdownFieldChanged(dropdownChangeEvent.value);
			}}
			value={fieldValue}
			className={classNames({ "p-invalid": !isValid })}
		/>
	);
};
